import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

const EASE = [0.16, 1, 0.3, 1];

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 32 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.9, delay, ease: EASE },
});

export const Manifesto = () => {
  const { t } = useLang();
  const PILLARS = [
    { nr: "01", title: t("manifesto.p1t"), body: t("manifesto.p1b") },
    { nr: "02", title: t("manifesto.p2t"), body: t("manifesto.p2b") },
    { nr: "03", title: t("manifesto.p3t"), body: t("manifesto.p3b") },
  ];
  return (
  <section id="huis" className="px-6 sm:px-12 lg:px-20 py-24 lg:py-32">
    <div className="grid lg:grid-cols-2 gap-14 lg:gap-24">
      <div>
        <motion.p {...reveal()} className="font-mono text-[10px] tracking-[0.35em] uppercase text-gold/85 mb-6">
          {t("manifesto.eyebrow")}
        </motion.p>
        <motion.h2
          {...reveal(0.08)}
          className="font-serif font-light uppercase text-cream text-3xl sm:text-4xl lg:text-5xl leading-[1.1]"
        >
          {t("manifesto.title1")}
          <span className="block italic normal-case text-gold">{t("manifesto.title2")}</span>
        </motion.h2>
        <motion.div {...reveal(0.16)} className="gold-hairline w-40 mt-10" />
        <motion.p {...reveal(0.22)} className="mt-10 font-mono text-[10px] tracking-[0.3em] uppercase text-smoke">
          {t("manifesto.stats")}
        </motion.p>
      </div>
      <div className="flex flex-col gap-12">
        <motion.p {...reveal(0.1)} className="text-sm sm:text-base leading-relaxed text-mist">
          {t("manifesto.body")}
        </motion.p>
        {PILLARS.map((p, i) => (
          <motion.div key={p.nr} {...reveal(0.14 + i * 0.08)} className="flex gap-6 border-t border-gold/10 pt-8">
            <span className="font-mono text-xs text-gold/70 pt-1">{p.nr}</span>
            <div>
              <h3 className="font-serif text-xl sm:text-2xl text-cream tracking-wide">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-mist">{p.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
  );
};

export default Manifesto;
